import type { HexColor } from '@getaccept/fried-tofu';
import { HeroSectionBackgroundType, type HeroSection } from '../types/hero-section';
import { HeroSectionLayoutOrder } from '../types/enums/hero-section-layout-order';
import { HeroSectionLayout } from '../types/enums/hero-section-layout';

export default class HeroSectionConstants {
  static defaultWidgetHeight = '555px';
  static mediaWidgetMaxWidth = '978px';
  static textWidgetWidth = '600px';
  static defaultBackgroundColor: HexColor = '#F8FAFC';

  static emptyState = (): HeroSection => ({
    textWidgetBackgroundColor: '#fff' as HexColor,
    background: {
      gradientColorOne: this.defaultBackgroundColor,
      gradientColorTwo: '#B0C7DD' as HexColor,
      gradientLightness: 0,
      type: HeroSectionBackgroundType.GradientSolid,
      imageId: undefined,
    },
    text: undefined,
    fields: [],
    layoutOrder: HeroSectionLayoutOrder.TextLeftMediaRight,
    layout: HeroSectionLayout.TextAndMedia,
    media: null,
    meetTeamText: undefined,
    showLogo: true,
  });
}
